import { Input } from "@/components/ui/input";
import { money } from "@/dealership/lib/desk";

/** Inline-editable money cell — every number on the worksheet uses this. */
export const MoneyField = ({ value, onChange, testid, placeholder = "0.00", disabled, className = "" }) => (
  <div className={`relative ${className}`}>
    <span className="absolute left-3 top-1/2 -translate-y-1/2 text-primary text-xs">$</span>
    <Input
      type="number" step="0.01" inputMode="decimal" disabled={disabled}
      value={value ?? ""} placeholder={placeholder}
      onChange={(e) => onChange(e.target.value === "" ? 0 : Number(e.target.value))}
      className="pl-7 pr-2 h-9 text-right money"
      data-testid={testid}
    />
  </div>
);

export const NumField = ({ value, onChange, testid, suffix, step = 1, min, max, className = "" }) => (
  <div className={`relative ${className}`}>
    <Input
      type="number" step={step} min={min} max={max} inputMode="decimal"
      value={value ?? ""} onChange={(e) => onChange(e.target.value === "" ? 0 : Number(e.target.value))}
      className={`h-9 text-right tnum ${suffix ? "pr-8" : ""}`}
      data-testid={testid}
    />
    {suffix && <span className="absolute right-3 top-1/2 -translate-y-1/2 text-xs text-muted-foreground">{suffix}</span>}
  </div>
);

export const TextField = ({ value, onChange, testid, placeholder, className = "" }) => (
  <Input value={value ?? ""} placeholder={placeholder} onChange={(e) => onChange(e.target.value)}
    className={`h-9 ${className}`} data-testid={testid} />
);

export const FieldRow = ({ label, hint, children, className = "" }) => (
  <div className={`flex items-center gap-3 ${className}`}>
    <div className="min-w-0 flex-1">
      <div className="label-mono">{label}</div>
      {hint && <div className="text-[11px] text-muted-foreground mt-0.5">{hint}</div>}
    </div>
    <div className="w-36 shrink-0">{children}</div>
  </div>
);

/** Read-only summary line. */
export const Line = ({ label, value, bold, gold, muted, negative, indent, testid, hint }) => (
  <div className={`flex items-baseline justify-between gap-3 py-1.5 ${indent ? "pl-4" : ""}`} data-testid={testid}>
    <span className={`text-sm ${muted ? "text-muted-foreground" : ""} ${bold ? "font-medium" : ""}`}>
      {label}
      {hint && <span className="block text-[11px] text-muted-foreground">{hint}</span>}
    </span>
    <span className={`tnum shrink-0 ${bold ? "font-heading text-lg" : "text-sm"} ${gold ? "money" : negative ? "text-red-400" : ""}`}>
      {typeof value === "number" ? money(value) : value}
    </span>
  </div>
);

export const Divider = () => <div className="border-t border-border/60 my-2" />;

/** Small on/off pill used for taxable / financed flags. */
export const MiniToggle = ({ on, onClick, onLabel, offLabel, testid, title }) => (
  <button
    type="button" onClick={onClick} title={title} data-testid={testid}
    className={`px-2 py-0.5 rounded-full border text-[10px] uppercase tracking-wider transition-colors ${
      on ? "bg-primary/12 border-primary/30 text-primary" : "bg-white/[0.03] border-border text-muted-foreground"
    }`}
  >
    {on ? onLabel : offLabel}
  </button>
);
